import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Col, Row, Typography, Tag, message } from "antd";
import { DownloadOutlined, FileExcelOutlined } from "@ant-design/icons";
import ModuleHeader from "../../components/ModuleHeader";
import { downloadTemplate as downloadRiderTemplate } from "../../services/riders.service";
import { downloadTransactionTemplate } from "../../services/transactions.service";
import "./Settings.css";

const { Text, Paragraph } = Typography;

const TEMPLATE_TILES = [
  {
    key: "riders",
    title: "Rider Bulk Upload",
    module: "Delivery Partners",
    format: "CSV",
    description:
      "CSV template for bulk uploading delivery partners (required columns and sample format).",
    fileName: "EZYGO_Rider_Bulk_Upload_Template.csv",
    download: downloadRiderTemplate,
  },
  {
    key: "transactions",
    title: "Transactions Upload",
    module: "Transactions",
    format: "CSV",
    description:
      "CSV template for Talabat-style daily uploads (Order_date, Rider ID → External Rider ID, Amount). Save Excel as CSV UTF-8 before uploading.",
    fileName: "EZYGO_Transactions_Upload_Template.csv",
    download: downloadTransactionTemplate,
  },
];

function downloadBlob(blob, fileName) {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
}

export default function TemplatesPage() {
  const navigate = useNavigate();
  const [downloadingKey, setDownloadingKey] = useState(null);

  const handleDownload = async (tile) => {
    setDownloadingKey(tile.key);
    try {
      const blob = await tile.download();
      downloadBlob(blob, tile.fileName);
      message.success(`${tile.title} downloaded`);
    } catch {
      message.error(`Failed to download ${tile.title}`);
    } finally {
      setDownloadingKey(null);
    }
  };

  return (
    <div>
      <ModuleHeader
        title="Settings"
        subtitle="Templates"
        backTo="/settings"
        onTitleClick={() => navigate("/settings")}
      />

      <div style={{ padding: "0 24px 24px" }}>
        <Paragraph type="secondary" style={{ marginBottom: 20, fontSize: 13 }}>
          Download system templates used for bulk uploads. Upload and version
          management will be added later.
        </Paragraph>

        <Row gutter={[16, 16]}>
          {TEMPLATE_TILES.map((tile) => (
            <Col xs={24} sm={12} md={8} lg={6} key={tile.key} style={{ display: "flex" }}>
              <Card className="settings-card template-tile-card" style={{ width: "100%" }}>
                <div className="template-tile-content">
                  <div className="template-tile-icon">
                    <FileExcelOutlined />
                  </div>
                  <Text strong className="settings-card-title">
                    {tile.title}
                  </Text>
                  <Text type="secondary" className="settings-card-desc template-tile-desc">
                    {tile.description}
                  </Text>
                  <div className="template-tile-meta">
                    <Tag>{tile.module}</Tag>
                    <Tag color="blue">{tile.format}</Tag>
                  </div>
                  <div className="template-tile-actions">
                    <Button
                      type="primary"
                      icon={<DownloadOutlined />}
                      block
                      loading={downloadingKey === tile.key}
                      onClick={() => handleDownload(tile)}
                    >
                      Download
                    </Button>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      </div>
    </div>
  );
}
